<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <template v-if="load_data_general">
    <div class="mt-2 flex flex-col">
      <div v-if="producers.length > 0" class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.producer.producer_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.producer.name") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("labels.crop_fields") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("labels.total_inspections") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="producer in producers"
                  :key="producer.id"
                  @click.prevent="goToListCropFields(producer)"
                >
                  <td class="table-cell-main link">
                    {{ producer.producer_code }}
                  </td>
                  <td class="table-cell link">
                    {{ producer.fullname }}
                  </td>
                  <td class="table-cell">
                    {{ producer.num_crop_fields_with_inspects }} /
                    {{ producer.num_crop_fields }}
                  </td>
                  <td class="table-cell">
                    {{ producer.num_inspects }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <alert-warning
        class="mt-8"
        v-else
        :warning_data="{
          title: $t('labels.no_producers_found')
        }"
      />
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import CropFieldQualityRequester from "@/views/agro_exporter/requesters/quality_control/crop_field/list_producers.js";

export default {
  name: "AEProductionCropFieldQualityListProducers",
  props: ["agro_exporter_id"],
  data() {
    return {
      load_data_general: false,
      producers: []
    };
  },
  methods: {
    fetchProducers: async function () {
      let response = await CropFieldQualityRequester.fetchProducers(
        this.agro_exporter_id
      );
      this.producers = response.data;
      this.load_data_general = true;
    },
    goToListCropFields: function (producer) {
      this.$router.push({
        name: "ae_quality_control_crop_field_list_crop_fields_path",
        params: {
          producer_id: producer.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchProducers())
    );
  }
};
</script>
